import React from 'react';

const occupations = ["clinical researcher", "neurologist", "doctor", "medical student", "nurse"];

export default class MarketingFeatures extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            occIndex: 0
        };
        this.interval = null;
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState((prevState) => ({
                occIndex: (prevState.occIndex + 1) % occupations.length
            }));
        }, 3000);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render() {
        const { occIndex } = this.state;
        return (
            <div id="features">
                <div className="section">
                    <div className="eyebrow reveal">
                        <div className="eyebrow-line"></div>
                        <span className="eyebrow-text">Core capabilities</span>
                        <div className="eyebrow-line"></div>
                    </div>
                    <h2 className="section-title reveal reveal-delay-1">
                        Everything a{' '}
                        <span
                            key={occupations[occIndex]}
                            className="text-fade-up feature-occ-highlight"
                        >
                            {occupations[occIndex]}
                        </span><br />
                        <em>actually needs</em>
                    </h2>
                    <p className="section-sub reveal reveal-delay-2">Axon isn't a generic AI. It's trained and grounded in the Neurochecklists knowledge base — so every answer is traceable, structured, and clinically reliable.</p>

                    <div className="feature-grid">
                        <div className="feature-card reveal reveal-delay-1">
                            <div className="feature-icon">🧠</div>
                            <div className="feature-title">Grounded Knowledge Base</div>
                            <div className="feature-desc">All responses are anchored to Neurochecklists' curated database of 4,000+ checklists and 240+ clinical guidelines. No hallucinations, every answer cited.</div>
                        </div>
                        <div className="feature-card reveal reveal-delay-2">
                            <div className="feature-icon">📋</div>
                            <div className="feature-title">Structured Checklists</div>
                            <div className="feature-desc">Axon returns clinical criteria in clean, interactive checklist format — ready to use at the bedside or embed in research documentation.</div>
                        </div>
                        <div className="feature-card reveal reveal-delay-3">
                            <div className="feature-icon">📄</div>
                            <div className="feature-title">Inline Citations</div>
                            <div className="feature-desc">Every claim links directly to its source — Lancet, NEJM, AAN guidelines, and more — so you can verify and cite with confidence.</div>
                        </div>
                        <div className="feature-card reveal reveal-delay-1">
                            <div className="feature-icon">🔬</div>
                            <div className="feature-title">Differential Diagnosis Aid</div>
                            <div className="feature-desc">Systematically work through differentials with Axon's guided protocol flow — from presenting symptoms to confirmed diagnosis criteria.</div>
                        </div>
                        <div className="feature-card reveal reveal-delay-2">
                            <div className="feature-icon">⚡</div>
                            <div className="feature-title">Real-Time Synthesis</div>
                            <div className="feature-desc">Cross-reference multiple guidelines simultaneously. Axon synthesises complex, multi-source information in seconds — not hours.</div>
                        </div>
                        <div className="feature-card reveal reveal-delay-3">
                            <div className="feature-icon">🔒</div>
                            <div className="feature-title">Research-Grade Privacy</div>
                            <div className="feature-desc">HIPAA-compliant infrastructure. Conversations are never used for training. Patient identifiers are never stored. Designed for clinical use.</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
